var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgARewardsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#439ac8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M166.62,156.38q-5.75,9.45-11.81,9.45a6.32,6.32,0,0,1-6-3.86q-1.94-3.85-1.94-19.49v-71q0-16.22-2.44-25.08t-12.9-14.86a39.81,39.81,0,0,0-11.07-4V0h-11V26c-3.39-.27-7-.41-11-.41q-4.1,0-7.93.23V0h-11V27q-15,2.45-25,9.1Q38.78,46.6,38.78,62a19.92,19.92,0,0,0,4,12.44q4.05,5.31,11.47,5.31a14.88,14.88,0,0,0,10.28-4.15q4.56-4.16,4.56-12.06a19.89,19.89,0,0,0-2.28-9.74,16.07,16.07,0,0,1-2.28-7.63q0-12,27.33-12,15.16,0,18.63,7.53T114,73.41V93.09q-84.66,4.64-84.66,53.83,0,15.83,10.45,26.73t28,10.9a43,43,0,0,0,11.74-1.62V200h11V178.11q10.08-6.08,18.9-17.85V200h11V173.12q7.26,11.41,21.52,11.43,24.28,0,28.67-28.17Zm-66,3q-8,7.62-18,7.62-7.75,0-13.74-7.14t-6-20.07q0-17.75,9.95-27.11T114,102V122.8q0,13.52-2.7,21.23T100.59,159.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgARewardsBlue);
export default __webpack_public_path__ + "static/media/a-rewards-blue.1720405146d15c44f74c18a4b3404f45.svg";
export { ForwardRef as ReactComponent };